document.addEventListener('DOMContentLoaded', function () {
  var announcementSlider = document.querySelector('[data-announcement-slider]');

  if (!announcementSlider || typeof Swiper === 'undefined') {
    return;
  }

  var slides = announcementSlider.querySelectorAll('.swiper-slide');
  var autoplayDelay = Number(announcementSlider.dataset.autoplayDelay) || 5000;

  new Swiper(announcementSlider, {
    loop: slides.length > 1,
    slidesPerView: 1,
    allowTouchMove: slides.length > 1,
    autoplay: slides.length > 1
      ? {
        delay: autoplayDelay,
        disableOnInteraction: false
      }
      : false
  });
});